import { PDFViewer, StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

import { BookingDetail } from '../../../types/bookingDetails'
import Main from './Page/Page'
import './index.css'

const styles = PDFStyleSheet.create({
  main: { width: '100vw', height: '100vh' }
})

interface CreatVoucherFAProps {
  data: BookingDetail | undefined
  masterReservationNumber: string
  stripTagsWithNewlines(html: string): string[]
  splitTextByWords(inputString: string, maxLength: number): string[]
}

const CreatVoucherFA = ({
  data,
  masterReservationNumber,
  stripTagsWithNewlines,
  splitTextByWords
}: CreatVoucherFAProps) => {
  return (
    <PDFViewer style={styles.main}>
      {data && (
        <Main
          data={data}
          masterReservationNumber={masterReservationNumber}
          stripTagsWithNewlines={stripTagsWithNewlines}
          splitTextByWords={splitTextByWords}
        />
      )}
    </PDFViewer>
  )
}

export default CreatVoucherFA
